import React from 'react';

import { Button, Tooltip } from '@mui/material';
import { Link } from 'react-router';

import { appRoutes } from '@clearverify/constants';

import { useCurrentUserPermissions } from 'src/hooks/user';
import { buildDirectEmployeeUrl } from 'src/utils/employeeSearchUrl';

type NavigateToEmployeeButtonProps = {
  /** The disputing employee; the button is absent when RLS hid them. */
  employeeId?: string | null;
};

/**
 * Opens the employee search on the disputing employee — the replacement for the
 * Employee Details page this used to link to.
 *
 * One dispute concerns one employee, so this belongs to the dispute as a whole
 * rather than to the per-employer items it's made of.
 */
export const NavigateToEmployeeButton: React.FC<NavigateToEmployeeButtonProps> = ({
  employeeId,
}) => {
  const { isPeoPayrollProviderUser } = useCurrentUserPermissions();

  if (!employeeId) return null;

  // Employee data isn't served to payroll providers yet, so the link would only
  // lead to an error — say so instead of quietly leaving them with nothing.
  if (isPeoPayrollProviderUser) {
    return (
      <Tooltip title="Employee records aren't available to payroll providers yet.">
        <span>
          <Button variant="outlined" disabled>
            Navigate to employee
          </Button>
        </span>
      </Tooltip>
    );
  }

  return (
    <Button
      component={Link}
      variant="outlined"
      to={buildDirectEmployeeUrl(appRoutes.employees.index, employeeId)}
    >
      Navigate to employee
    </Button>
  );
};
